<template>
  <div>
    <question :idx="4">
      <p class="title">4、关于房地产置业投资说法，正确的是（）</p>
      <ul>
        <li class="error"><span style="display: none">A</span><Icon type="md-close-circle" color="#ff3300"/>房地产置业投资的对象只能是旧房地产</li>
        <li><span>B</span>房地产置业投资属于间接投资</li>
        <li class="zhengque"><span style="display: none">C</span><Icon type="md-checkmark-circle" color="#009900"/>房地产置业投资的目的是自用或获取</li>
        <li><span>D</span>房地产出租不属于房地产置业投资</li>
      </ul>
      <Button  class="btn" @click="next">下一题</Button>
    </question>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
</style>
<script type="text/ecmascript-6">
  import question from '../template/question'
    export default {
        name: '',
        props: {},
        data() {
            return {};
        },
        methods: {
          next(){
            this.$router.push({
              path: '/que4'
            })
          }
        },
        created() {

        },
        components: {
          question
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/question/qus4.vue